export const DEALER_REPORT_DATE_RANGES = [
  { value: "last_7_days", label: "Últimos 7 días" },
  { value: "last_30_days", label: "Últimos 30 días" },
  { value: "this_month", label: "Este mes" },
  { value: "trial_period", label: "Periodo de prueba" },
];

export const DEFAULT_DEALER_REPORT_RANGE = "last_30_days";

export const TRIAL_READINESS_LABELS = {
  strong_candidate: "Candidato fuerte",
  needs_more_leads: "Necesita más leads",
  needs_inventory_cleanup: "Inventario por mejorar",
  poor_response: "Respuesta lenta",
  insufficient_data: "Datos insuficientes",
};

export const LISTING_ACTION_LABELS = {
  add_photos: "Agrega fotos",
  confirm_availability: "Confirma disponibilidad",
  improve_description: "Mejora descripción",
  review_price: "Revisa precio",
  respond_leads: "Responde leads",
  mark_sold: "Marca como vendido",
  edit_listing: "Editar publicación",
};

export function trackDealerPerformanceEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[dealer-performance]", eventType, metadata);
  }
}

export function formatPercent(value) {
  if (value == null) return "—";
  return `${value}%`;
}
